var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AnonymousIdentity } from './Identity';
import glue from '../glue';
import { EventManager } from '../utils';
/**
 * Database authentication is an authentication by cookie and username password.
 */
export class DatabaseAuthentication {
    constructor() {
        this.eventManager = new EventManager();
    }
    get currentUser() {
        return this._currentUser;
    }
    set setCurrentUser(value) {
        this._currentUser = value;
    }
    authenticate(request) {
        request.credentials = 'include';
        return request;
    }
    login() {
        glue.browserHistory.push('/login', {
            redirect: glue.browserHistory.location.pathname
        });
    }
    loginWith(username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const params = new URLSearchParams();
                params.append('username', username);
                params.append('password', password);
                yield glue.api.post("/api/auth/login", params);
                const identityRequest = yield glue.api.get("/api/me", {
                    maxRedirects: 0
                });
                if (200 === identityRequest.status) {
                    this._currentUser = identityRequest.data;
                    this.eventManager.fire("login");
                }
                return this._currentUser;
            }
            catch (e) {
                throw new Error("Failed authentication");
            }
        });
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            yield glue.api.post("/api/auth/logout");
            this._currentUser = new AnonymousIdentity();
            this.eventManager.fire("logout");
            return undefined;
        });
    }
    on(eventKind, callback) {
        return this.eventManager.addListener(eventKind, callback);
    }
    init(glue) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const authRequest = yield glue.api.get("/api/me", {
                    maxRedirects: 0
                });
                if (200 === authRequest.status) {
                    this._currentUser = authRequest.data;
                }
            }
            catch (e) {
            }
            return this;
        });
    }
}
//# sourceMappingURL=DatabaseAuthentication.js.map